class AppNavigation extends Component {
	constructor(el) {
		super(el);
		this.closer = this.$find('[data-closer]');
		this.subNavOpeners = this.$findAll('[data-opener]');
		this.addEventListeners();
	}

	openNav() {
		this.$el.classList.add('is-opened');
	}

	closeNav() {
		this.$el.classList.remove('is-opened');
	}

	toggleSubNav(opener) {
		opener.classList.toggle('is-opened');
		opener.nextElementSibling.classList.toggle('is-opened');
	}

	closeSubNav() {
		this.subNavOpeners.forEach(opener => {
			opener.classList.remove('is-opened');
			opener.nextElementSibling.classList.remove('is-opened');
		});
	}

	addEventListeners() {

		this.closer.addEventListener('click', () => {
			this.closeNav();
			this.closeSubNav();
		});

		this.subNavOpeners.forEach(opener =>
			opener.addEventListener('click', () => this.toggleSubNav(opener))
		);

		EventBus.getInstance().addEventListener('mainNavigationOpen', () => this.openNav());

		window.addEventListener('scroll', () => {
			if (this.$el.classList.contains('is-opened')) {
				this.closeNav();
				this.closeSubNav();
			}
		});

		document.addEventListener('click', (event) => {
			if (this.$el.classList.contains('is-opened') && !this.$el.contains(event.target)) {
				this.closeNav();
				this.closeSubNav();
			}
		});
	}

}
